import cookie from 'cookie';
import ApiService from './api.service';
import asyncWrapper from '../utils/asyncWrapper';

const CloudfrontCookieService = {
  exists() {
    const cookies = cookie.parse(document.cookie);
    const id = cookies['CloudFront-Key-Pair-Id'];
    const signature = cookies['CloudFront-Signature'];
    const policy = cookies['CloudFront-Policy'];
    return id && signature && policy;
  },
  getRemainingTime() {
    if(!this.exists())
      return -1;

    try {
      const policyB64 = cookie.parse(document.cookie)['CloudFront-Policy'];
      const buff = new Buffer.from(policyB64, 'base64');
      const policy = JSON.parse(buff.toString('utf8').slice(0, -1));
      const expireTime = parseInt(policy.Statement[0].Condition.DateLessThan['AWS:EpochTime']);
      const now = Math.floor((new Date().getTime() / 1000));
      return expireTime - now;
    } catch(error) {
      console.error(error);
      return -1;
    }
  },
  async refreshCookies() {
    const time = this.getRemainingTime();
    if(time < 60){
      const response = await asyncWrapper(ApiService.get('documentation'));
      const cookies = response.result;
      for(let key in cookies) {
        document.cookie = cookie.serialize(key, cookies[key], {
          path: '/',
        });
      }
    }
  }
}

export default CloudfrontCookieService;